import http from '../http'
import url from './index-url'
const { get } = http

export default {
  /**
   *
   * @param {*} classTypeId  班型id
   * @param {*} lessonId 讲次id
   * @returns
   */
  getLessonCourseware(classTypeId, lessonId) {
    return get(`${url.getLessonCourseware}/${classTypeId}/${lessonId}`)
    //   return get(`https://yapi.aixuexi.com/mock/42/teacherapi/courseware/${classTypeId}/${lessonId}`)
  }
}